module.exports = __webpack_public_path__ + "d4c061e84ef0fc3399bae3a2de77502a.svg";